import { readSkySetting, readThemeSetting, SKY_STORAGE_KEY, THEME_STORAGE_KEY, type SkySetting, type ThemeSetting } from "./scene";

export const SKY_SETTINGS_EVENT = "busee:appearance-change";

/* The old "busee.companions" key may still sit in localStorage from builds
   that had companion characters. Nothing reads it any more, so a stale value
   is harmless and is simply ignored. */

export function readAppearancePreferences() {
  try {
    return {
      theme: readThemeSetting(window.localStorage),
      sky: readSkySetting(window.localStorage),
    };
  } catch {
    return { theme: "system", sky: "random" } satisfies {
      theme: ThemeSetting;
      sky: SkySetting;
    };
  }
}

export function saveAppearancePreference(
  preference: { kind: "theme"; value: ThemeSetting } | { kind: "sky"; value: SkySetting },
): boolean {
  const key = preference.kind === "theme" ? THEME_STORAGE_KEY : SKY_STORAGE_KEY;
  try {
    window.localStorage.setItem(key, preference.value);
    window.dispatchEvent(new CustomEvent(SKY_SETTINGS_EVENT));
    return true;
  } catch {
    return false;
  }
}
